import React, { type ReactNode } from "react";
import DeleteConfirmModalBase from "./DeleteConfirmModalBase";
import { deleteModalBracedCount } from "./deleteModalSupporting";

export interface BulkDeleteConfirmModalProps {
  open: boolean;
  entityLabel: string;
  count: number;
  supportingTextSuffix?: string;
  title?: string;
  supportingText?: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  primaryLabel?: string;
}

const DEFAULT_SUPPORTING_TEXT_SUFFIX =
  "This action will permanently remove them and their permissions from the platform.";

export default function BulkDeleteConfirmModal({
  open,
  entityLabel,
  count,
  supportingTextSuffix = DEFAULT_SUPPORTING_TEXT_SUFFIX,
  title: titleProp,
  supportingText: supportingTextProp,
  onClose,
  onConfirm,
  confirmDisabled = false,
  primaryLabel,
}: BulkDeleteConfirmModalProps) {
  const title = titleProp ?? `Delete ${entityLabel}${count !== 1 ? "s" : ""}`;
  const supportingText: ReactNode =
    supportingTextProp ??
    (count > 0 ? (
      <>
        {"You're about to delete "}
        <strong>{deleteModalBracedCount(count)}</strong>
        {` ${entityLabel}${count !== 1 ? "s" : ""}. ${supportingTextSuffix}`}
      </>
    ) : (
      ""
    ));

  return (
    <DeleteConfirmModalBase
      open={open}
      title={title}
      supportingText={supportingText}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmDisabled={confirmDisabled}
      primaryLabel={primaryLabel}
    />
  );
}
